import Vue from 'vue';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import VueAnalytics from 'vue-analytics';
import axios from './plugins/axios.js';
import App from './components/app-root.vue';
import vuetify from './plugins/vuetify';
import router from './router/routes.js';
import {
  roles,
  checkAuth,
  setup,
  sessionExpired,
} from './auth/auth';
import store from './store';
import { rules } from '$root/validation.js';
import ErrorModule from './modules/error';
import SnackbarModule from './modules/snackbar';
import ConfirmModule from './modules/confirm';
import config from '$root/config.js';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';


Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'md',
});
Vue.use(ErrorModule);
Vue.use(SnackbarModule);
Vue.use(ConfirmModule);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$rules = rules;
Vue.prototype.$auth = { roles, checkAuth };

Object.defineProperties(Vue.prototype, {
  $config: {
    get() {
      return store.getters.config;
    },
  },
});

setup(router, Vue);

axios.interceptors.response.use(null, (error) => {
  if (!error?.response) {
    Vue.prototype.$error('Error communicating with server');
  } else if (error.response.status === 401) {
    sessionExpired();
  } else if (error.response.status === 403) {
    Vue.prototype.$error('You do not have permission to perform this action.');
  } else {
    const errMsg = error?.response?.data?.detail || error?.response?.data?.title;
    const fieldErrors = Object.keys(error?.response?.data?.errors ?? {})
      .map((k) => `${error?.response?.data?.errors[k]}`).join('\n');

    Vue.prototype.$error(`${errMsg}\n\n${fieldErrors}`);
  }

  return Promise.reject(error);
});

router.afterEach((to) => {
  if (to.params.lenderCode != null) {
    store.commit('setLenderCode', to.params.lenderCode);
  }
});

store.dispatch('financeCompanies/getItems');
store.dispatch('updateConfigs');

Vue.use(VueAnalytics, {
  id: 'UA-177955094-1',
  disabled: config.DisableGoogleAnalytics,
  router,
});

new Vue({
  router,
  store,
  axios,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
